/**
 * ImProvider — wraps the inter-PS instant messaging state for any pro page.
 * Always mounted at app root; the hook itself bails out if no pro token.
 */
import React, { createContext, useContext } from "react";
import { useInstantMessagingClient } from "./useInstantMessaging";

const ImCtx = createContext(null);

export function ImProvider({ children }) {
  const value = useInstantMessagingClient();
  return <ImCtx.Provider value={value}>{children}</ImCtx.Provider>;
}

export function useIm() {
  const ctx = useContext(ImCtx);
  if (!ctx) throw new Error("useIm must be used within ImProvider");
  return ctx;
}
